<template>
<div>
  <div class="pony-images-section">
    <PonyImageSlideshow
      v-if="images.length"
      :user="user"
      :images="images"
      :authenticated="authenticated"
      @prevImage="prevImage"
      @nextImage="nextImage"
    />
    <p v-else>There are no images for this pony</p>
  </div>
  <PonyImageManager
    v-if="showManager"
    @addedImage="updateImages"
    :slug="slug"
    :user="user"
  />
</div>
</template>

<script>
import { mapState } from 'vuex'
import PonyImageManager from '../PonyImageManager/PonyImageManager';
import PonyImageSlideshow from '../PonyImageSlideshow/PonyImageSlideshow';

export default {
  name: 'PonyImages',
  props: {
    slug: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      default: () => ([]),
    }
  },
  data() {
    return {
      showManager: false
    };
  },
  components: {
    PonyImageManager,
    PonyImageSlideshow
  },
  methods: {
    nextImage({ image }) {
      this.$store.dispatch('pony/UPDATE_IMAGES', {
        slug: this.slug,
        image
      })
    },
    prevImage({ image }) {
      this.$store.dispatch('pony/UPDATE_IMAGES', {
        slug: this.slug,
        image,
      })
    },
    toggleImageManager() {
      this.showManager = this.showManager ? false : true;
    },
    updateImages() {
      // console.log(payload)
      // dispatch action to add image to pony images
    },
    removeImage() {
      // console.log(payload)
      // dispatch action to remove image to pony images
    }
  },
  computed: {
    ...mapState({
      user: state => state.currentUser.currentUser,
      authenticated: state => state.currentUser.authenticated
    }),
    buttonText() {
      return this.showManager ? 'Less Images' : 'More Images';
    }
  }
};
</script>

<style lang="scss" scoped>
.pony-add-images {
  padding-top: 20px;
  padding-bottom: 20px;

  .dropzone {
    margin: 20px 0;
    width: 100%;
    max-width: none;
  }
}
</style>
